function isJson(str) {
   if (typeof(str) === "object" && str.constructor == Object) {
     return true
   } else {
     return false
   }
}

function isEmpty(obj) {
   for (var x in obj) { if (obj.hasOwnProperty(x))  return false; }
   return true;
}

const pako = require('pako');
const btoa = require("Base64").btoa
const atob = require("Base64").atob
// import ajax from "./Ajax"
// import {escapeRegExp}  from "./re"
var ajax = require('./Ajax');
var escapeRegExp = require('./re');
const config = require ("./config.json");
var commonmark = require('./commonmark');
const BLENDED_DIR = config.blended_directory;
const ACTIVE_ORGANISATION = config.active_organsation;
const ALLOWED_MEDIA_TYPES = ['jpg','jpeg','bmp','gif','tif','png','ico','webp','otf','eot','svg','ttf','woff','woff2']


class Controller {
    constructor(backend, network) {
        this.backend = backend
        this.network =  network
        this.uuid_map = {}
        this.theme_setting = []
        this.Intermediary = this.backend.get_class("intermediary")
        this.Directory = this.backend.get_class("Directory")
        this.JSONFile = this.backend.get_class("JSONFile")
        this.BinaryFile = this.backend.get_class("BinaryFile")
        this.TextFile = this.backend.get_class("TextFile")
    }

    get_package(package_name = null , format = null , version = null, trim = true, dependency = false, callback) {
      /*
      *  it will load the intermediary project object in the jptf structure or in the proper context structure of the json format
      *  it will call the backend based on the backend name passed to it.for default it will use memory ...
      */
      let accountSlug = package_name.split("/")[0];
      let slug = package_name.split("/")[1];
      let project = {}
      let backend  = this.backend 
      backend.get_package (package_name, (data) => {
        project = data;
     
      //console.log(package_name);
        if (!project) {  
          const self  = this
          this.network.localDownload(accountSlug, slug, {}, (data, response) => {
            if(response) {
              var resp= {};
              try{
                resp = JSON.parse(response.text);
              } catch(e){}
              if (response.status == 200) {
                self.save_local(self.deserialize_jptf(project = resp), package_name, (url) => {
                  self.network.getFile(accountSlug, slug, ".hash", (data, response) => {
                    if(response){
                      let respp = {};
                      try{
                        respp = JSON.parse(response.text);
                      } catch(e){}
                      if(response.status === 200 && respp.hasOwnProperty("packageHash")){
                        self.backend.set_hash(accountSlug + "/" + slug + ".hash", respp.packageHash);
                      } else {
                        self.backend.set_hash(accountSlug + "/" + slug + ".hash", "");
                      }
                    } else {
                      self.backend.set_hash(accountSlug + "/" + slug + ".hash", "");
                    }
                    self.get_package(package_name  , format , version, trim, dependency , callback);
                  });
              });
              } else {
                throw new Error(data.message);
              }
            } else {
              throw new Error(data.message);
            }
          })
        } else {
          // this.save_local (_project);
          if(format == "jptf") {
             return callback (this.as_jptf(project))
          } else if (format == "context") {
              // Todo : can call to host
              project = this.as_context (project);
              return callback (project)
          } else {
              return callback (project)
          }
        }
       })

    }

    deserialize_jptf (project_object) {
      // convert jptf into intermediary format
      try {
        var intermediary = this.jptf_to_intermediary(project_object);
        var obj = new this.Directory(intermediary[0].location, intermediary[0].content, intermediary[0].name, intermediary[0].hash);
        return obj;
      } catch (e) {
        throw new Error("BlendedError: deserialize_jptf")
      }
    }

    jptf_to_intermediary (project_object) {
      //  => called from deserialize_jptf

      if(typeof project_object !== "object"){
        throw new Error("BlendedError: jptf_to_intermediary");
      }

      var data = [], name= "", location = "",hash="";
      for (var i in project_object){
          var dict_copy = {};
          var project_object_iter = project_object[i];
          var keys = Object.keys(project_object_iter)

          for (var j_key in keys) {
              var key = keys[j_key];
              var value = project_object_iter[key]
              if (value['type'] == 'directory'){
                  var content = this.jptf_to_intermediary(value['content'])
                  data.push(new this.Directory(location=key, content=content, name=key, hash=value['hash']))
              } else if (value['type'] == 'file' && key.split(".")[key.split('.').length-1] =='json'){
                  if(value['content'] !== undefined){
                    var content = this.decompress_string(value['content'])
                  } else {
                    var content = "";
                  }
                  data.push(new this.JSONFile(location=key, content=content, name=key, hash=value['hash']))
              } else if (value['type'] == 'media'){
                  if(value['href'] !== undefined){
                    var content = value['href'];
                  } else {
                    var content = "";
                  }
                  data.push(new this.BinaryFile(location=key, content=content, name=key, hash=value['hash']))
              } else if (value['type'] == 'file'){
                  if(value['content'] !== undefined){
                    var content = this.decompress_string(value['content'])
                  } else {
                    var content = "";
                  }
                  data.push(new this.TextFile(location=key, content=content, name=key, hash=value['hash']))
              } else {
                  data = project_object;
                  break;
              }
          }
      }
      return data
    }


    save_local (project_object, package_name, callback) {
      //save the project in intermediary structure in the local
      try {
        let url = "";
        this.backend.save_package (project_object, package_name, (data) => {
            url = data;
            return callback(url);
        });
        //Save hub
        // return url
      } catch (e) {
         throw new Error ('blendedError')
      }
    }

    save_hub (blended_project) {
      let project = this.as_jptf (blended_project);
      //TODO : call the host
    }

    validate_local (project_object) {
      //TODO
      let project =  this.as_jptf (project_object);
      this.backend.validate(project)
    }

    validate_hub (project_object) {
      let project =  this.as_jptf (project_object);
      //TODO
    }

    save_js (name,content) {
      let url =  this.backend.save_js (name , content);
      return url;
    }

    save_css (name,content) {
      let url =  this.backend.save_css (name , content);
      return url;
    }

    get_image (image_url) {
      let image =  this.backend.load_image(image_url);
      return image
    }

    load_image (image_url) {
      /* This is simmiler to the get Image .
         python is returning pil format in it */
      let image =  this.backend.load_image(image_url);
      return image
    }

    save_image (image_name ,image_content) {
      let  url =  this.backend.save_image (image_name,  image_content);
      return url;
    }

    as_jptf (intermediary){
      // convert intermediary to jptf object

        var dict_copy =  Object.assign({}, intermediary);
        var jptf = this.intermediary_to_jptf(intermediary.content);
        var obj = [{"/" : {"type" : "directory", "hash" : dict_copy.hash, "content" : jptf}}];
        return obj;
    }

    intermediary_to_jptf (project_object) {
      // => called from as_jptf

      try{
          for (var index in project_object){
              var item = project_object[index],
                  key = item.name,
                  value = item.content,
                  keys = key.split(".");  //TODO  if abc.cde.html => [abc.cde, html]
              if(keys.length > 1){
                  var with_extension = true;
                  var extension = key.split(".")[key.split('.').length-1];
              } else {
                  var with_extension = false
              }
              if(value instanceof Array){
                  value = this.intermediary_to_jptf(value)
                  project_object[index] = {[key]: {"type": "directory", "content": value, "hash": item.hash}}
              } else if(with_extension &&  ALLOWED_MEDIA_TYPES.indexOf(extension.toLowerCase()) > -1){
                  project_object[index] = {[key]: {"type": "media", "href": value, "hash": item.hash}}
              } else if(item instanceof this.JSONFile){
                  value = this.compress_string(value)
                  project_object[index] = {[key]: {"type": "file", "content": value, "hash": item.hash}}
              } else if (item instanceof this.TextFile){
                  value = this.compress_string(value);
                  project_object[index] = {[key]: {"type": "file", "content": value, "hash": item.hash}}
              }
          }
          return project_object
      } catch(e){
          return null
      }
    }


    as_context (project, trim = true, dependency = false) {
     /*
      *  as_context function is used to turn a project object in intermediary format into context format.
      *  It also resolves all the json pointers including those pointing to dependencies before it returns it
      */
      // project =  this.array_to_obj(project)
      let dependency_list =[]
      var dependency_dict = {};
      project =  this.intermediary_to_context(project);
      try {
        let project_json =  project["_package.json"]
        let dependency_list =  project_json.dependencies
      } catch (e) {
        throw new Error ("BlendedError")
      }

      dependency_dict =  this.load_dependency (dependency_list)
      project = Object.assign (project , dependency_dict)
      project =  this.order_project_dict (project)
      project =  this.resolve(null,  project,  dependency_dict,null)
      if(trim){
          project = this.trim_context(project)
      }
      return project
    }

    intermediary_to_context (project, obj_to_return = null){
      project = project.content;
      if(!obj_to_return){
        obj_to_return = {}
      }
      for(var item in project){
        var value = project[item];
        var key = value.name;

        if(value.content instanceof Array){
            obj_to_return[key] = this.intermediary_to_context(value, obj_to_return[key]);
        } else if(value instanceof this.BinaryFile){
            obj_to_return[key] = value.location;
        } else {
            if(key.endsWith('.json')){
                value = JSON.parse(value.content)
            } else {
                value = value.content;
            }
            obj_to_return[key] = value;
        }
      }
      return obj_to_return;
    }

    trim_context (current_node) {
      let current_node_iter  =  Object.assign ({}, current_node);
      if (isJson(current_node_iter)) {
        let keys =  Object.keys (current_node_iter)
        for (var i in keys) {
          let key =  keys [i];
          let value =  current_node_iter[key];
          if (key == "_index.json") {
            //value = JSON.parse (value)
            let index_keys =  Object.keys(value)
            for (var j in index_keys) {
               let index_key =  index_keys[j];
               let index_value =  value[index_key];
               current_node [index_key] =  index_value;
            }

            if (Object.keys(current_node).indexOf(key) > -1) {
              delete current_node[key];
            }
          }
          else if (key.startsWith("_")) {
                if (key in current_node_iter) {
                  delete current_node[key]
                }
          } else if (key.indexOf(".") > -1) {
            let new_key =  key.substring(0, key.indexOf("."));
            current_node [new_key] = value;
            if (key in current_node) {
              delete current_node[key];
            }
          }
          if (isJson(value)) {
            this.trim_context (value)
          }
        }
      }
      return current_node
    }



    order_project_dict (project_object) {
      /*var dict = {
          "word_21": "Hello Java",
          "word_22": "Hello World",
          "word_11": "Hello Javascript"
      }; dummy data for testing */
      var keys =  Object.keys (project_object);
      keys.sort ();
      var dict = {};
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value =  project_object[key];
        dict[key] = value
      }
      return dict
    }


    load_dependency (dependency_list) {
      let dependency_dict = {};
      for (var variable in dependency_list) {
        let dependency =  dependency_list [variable];
        let dep_uuid = dependency['uuid'];
        let dep_alias =  dependency['alias'];
        let project =  this.get_package (dep_uuid, 'context' , null);
        dependency_dict[dep_alias] =  project;
       }
       return dependency_dict;
     }

    // get_directory (uuid) {
    //    let uuid_map = this.get_uuid_map();
    //    let directory =  uuid_map[uuid];
    //   return directory;
    // }
    //
    // get_uuid_map () {
    //   if (!isEmpty(this.uuid_map)) {
    //     return this.uuid_map
    //   }
    //
    //   let uuid_map = {};
    //   let layouts =  BLENDED_DIR + "/" + ACTIVE_ORGANISATION + "/" + "layouts"
    //   let themes =  BLENDED_DIR + "/" + ACTIVE_ORGANISATION + "/" + "themes"
    //   let theme_group =  BLENDED_DIR + "/" + ACTIVE_ORGANISATION + "/" + "theme_group"
    //   Object.assign(uuid_map, this.get_uuids(themes));
    //   //uuid_map
    //            //.concat (this.get_uuids(layouts))
    //            //.concat (this.get_uuids(themes))
    //            //.concat (this.get_uuids(theme_group));
    //   this.uuid_map =  uuid_map;
    //   return uuid_map;
    // }
    //
    // get_uuids (directory_path) {
    //   /*Not sure how to use directory path*/
    //   let uuid_map = {};
    //   let projects =  this.backend.get_all_project ();
    //   for (var project_no in projects) {
    //      let project = projects[project_no];
    //      let key  =  project["_project.json"].uuid;
    //      uuid_map[key] = project; /*the key in localStorage for the saved project is same as uuid */
    //   }
    //   return uuid_map
    // }

    resolve (current_node , project_object , dependency_dict , current_json_file) {
      //var isArray = true; // need to research
      if (!current_node) {
        current_node =  project_object
      }
      let keys =  Object.keys (current_node);
      for (var i = 0; i < keys.length; i++) {
         var key =  keys [i];
         var value =  current_node[key];
         var fileExt =  (/[.]/.exec(key)) ? /[^.]+$/.exec(key) : undefined;
         if (fileExt) {
           if (fileExt[0] === "json") {
             current_json_file =  current_node[key]
           }
         };

         let current_value =  current_node[key]
         if (isJson(current_value)) {
            if (!value) {
              // continue
            }
            else if ('$ref' in value) {
               let set_val =  new Set ();
               current_node [key] =  this.resolve_pointer (current_value, project_object, dependency_dict, set_val, current_json_file);
            }
            else  {
               this.resolve (value , project_object ,  dependency_dict, current_json_file)
            }
         }
      }
      return project_object;
    }

    resolve_pointer (json_ref, project_object, dependency_dict, visited_set, current_json_file ) {
      if (isJson(json_ref) && ('$ref' in json_ref)) {
          let pointer = json_ref['$ref'];
          if (visited_set.has(pointer)) {
             throw new Error ("BlendedError: A Json Pointer cycle has been detected")
          }
          else {
            visited_set.add (pointer)
            json_ref =  this.ref_get (pointer,  project_object,  current_json_file, dependency_dict,  visited_set)
            if (!json_ref) {
              throw new Error("BlendedError : A Json Pointer cycle has been detected ")
            }
            this.resolve_pointer(json_ref, project_object,  dependency_dict, visited_set,  current_json_file);
          }
      }
      return json_ref;
    }


    ref_get (ref_value, project_object, json_file, dependency_dict, visited_set){
      let dicti_replace = {'#/' : ''}
      let dicti_replace1 = {'#' : ''}
      if (ref_value.indexOf("@") === 0) {
        let ref_point =  ref_value.indexOf("/");
        let path =  ref_value.substring(ref_point + 1 ,  ref_value.length);
        let alias_name =  ref_value.substring(1, ref_point);
        ref_value =  this.get_value_at_path(path , dependency_dict[alias_name]);
        return ref_value;
      }
      else if (ref_value.indexOf("#/") == 0){
        let path =  this.multiple_replace (dicti_replace , ref_value);
        ref_value = this.get_value_at_path(path, json_file);
        if (isJson (ref_value)){
          if ('$ref' in ref_value) {
              if (ref_value['$ref'] in visited_set) {
                 throw new Error ("BlendedError : A Json Pointer cycle has been detected ")
              }
              visited_set.add(ref_value['$ref']);
              ref_value =  this.ref_get(ref_value['$ref'], project_object, json_file, dependency_dict, visited_set)
              return ref_value
          }
        }
        return ref_value
      }
      else {
         let path =  this.multiple_replace (dicti_replace1 , ref_value);
         ref_value =  this.get_value_at_path (path, project_object);
      }
      return ref_value
    }



    get_value_at_path (dir_path , project_object) {
      let path =  dir_path.split('/')
      let unchanged_project_object =  Object.assign({} , project_object)
      let temp_value =  project_object
      for (var variable in path) {
         let value = path [variable]
         try {
            if ('$ref' in temp_value) {
              let ref_value =  temp_value['$ref'];
              temp_value =  this.ref_get ( ref_value,
                                           unchanged_project_object,
                                           unchanged_project_object,
                                           {},
                                           new Set()
                                          )
            }
            temp_value = temp_value[value]
         } catch (e) {
           return value + 'not found'
         }
      }
      return temp_value
    }

    multiple_replace (dic ,  text) {
       var key =  Object.keys (dic)[0]
       var pattern =  escapeRegExp (key) //  This will return the pattern , based on the passed object keys
       return text.replace (new RegExp(pattern) , dic[key]);
    }

    make_active (theme_name) {
      let backend  = this.backend;
      return backend.make_active(theme_name)
    }

    array_to_obj (intermediary ,  obj_to_return ={}){
      for (var i in intermediary) {
        let jptf_node =  intermediary[i]
        let jptf_node_keys = Object.keys (jptf_node)[0] //As there is only one
        let internal_jptf_node = jptf_node[jptf_node_keys]
        if (Array.isArray(internal_jptf_node)) {
          obj_to_return[jptf_node_keys] = {}
          this.array_to_obj (internal_jptf_node, obj_to_return[jptf_node_keys] )
        } else {
           let isJSONFile  =  new RegExp (/\.(json)$/i)
           if (isJSONFile) {
            obj_to_return[jptf_node_keys] = internal_jptf_node
           } else {
            obj_to_return[jptf_node_keys] = internal_jptf_node
           }
        }
      }
      return obj_to_return
    }

    compress_string (str) {
      let deflated =   pako.deflate(str, { to: 'string' })
      let encodedData = btoa(deflated)
      return encodedData
    }

    decompress_string (str) {
      let decodedData = atob(str)
      let deflated =   pako.inflate(decodedData, { to: 'string' })
      return deflated
    }



    set_pk_map (data) {
      let pk_map = {}
      const item =  data['items']
      for (var i in item) {
        if (item.hasOwnProperty(i)) {
          pk_map[item[i].name] =  item[i].pk
        }
      }
      return this.backend.set_pk_map (pk_map)
    }

    /* Setting app*/
    setThemeSetting (data) {
      this.theme_setting.push(data)
    }

    getThemeSetting (data) {
      return this.theme_setting
    }

    getThemeSettingPosition (index) {
       return this.theme_setting (index)
    }

    doUndo () {
      let data = this.backend.doUndo ()
      return data
    }

    undoStack () {
      return this.backend.undoStack
    }

    doRedo () {
      let data =  this.backend.doRedo ()
      return data
    }

    redoStack () {
      return this.backend.redoStack
    }

    revert () {
      let data =  this.backend.revert ()
      return data;
    }

    pushLocalChanges (data) {
      this.backend.pushLocalChanges (data)
    }

    clearStack () {
      this.backend.clearStack ()
    }

    difference (text1, text2) {
      /* This difference is for line by line  */
      var arr1 = text1.split("\n");
      var arr2 = text2.split("\n");

      var diff = "";
      var arr1Len = arr1.length; // length of first array
      var arr2Len = arr2.length; // length of second array

      for(var i=0; i<arr1Len; i++){
        if(arr1[i] != arr2[i]){

          diff = diff + "-" + arr1[i] + "\n";
          diff = diff + "+" + arr2[i] + "\n";
        }
      }
      return diff;
    }

    commonmark (string) {
      var reader = new commonmark.Parser();
      var writer = new commonmark.HtmlRenderer();
      var parsed = reader.parse(string); // parsed is a 'Node' tree
      // transform parsed if you like...
      var result = writer.render(parsed); // result is a String

      return result
    }

    generateChallangeResponse(activationChallenge){
      var item = activationChallenge.operands;
      var operator = activationChallenge.operator;
      var number1 = item[0];
      if(operator != "SQUARE"){
        var number2 = item[1];
      }
      var answer;
      switch(operator){
        case "SQUARE":
            answer = number1 * number1;
            break;
        case "MULTIPLY":
            answer = number1 * number2;
            break;
        case "DIVIDE":
            answer = parseInt(number1 / number2);
            break;
        case "MODULO":
            answer = parseInt(number1 % number2);
            break;
        case "SUM":
            answer = number1 + number2;
            break;
        case "SUBTRACT":
            answer = number1 - number2;
            break;
      }
      return answer;
    }

    pushPackage (accountSlug, slug, body, callback) {
      var self = this;
      var package_name  = accountSlug + "/" + slug;
      var local_package = {};
      var hub_package   = {};
      var local_last_packageHash = this.backend.get_hash(package_name + ".hash");
      this.backend.remove_package();
      if(body.hasOwnProperty("pushToHub") && body["pushToHub"]){
        this.network.pushPackage(accountSlug, slug, body, (data, response) => {
            return callback(data, response);
        });
      } else {
        this.get_package(package_name, null, null, true, false, (_project) => {
          let found = false;
          for (var key in _project["content"]){
              if( _project["content"][key]["name"] === "_package.json"){
                found = true;
                break;
              }            
          }
          if(!found){
            return callback({}, {"status": 500, "text":JSON.stringify({"message": "Invalid package. \"_package.json\" file not found.  This file must be present on root directory."})});
          }
          local_package = _project
          this.network.pullPackage (accountSlug, slug, {"asHash": true}, (data, response) => {
            if(response){
              var resp= {};
              try{
                resp = JSON.parse(response.text);
              } catch(e){

              }
              if(response.status === 200){
                  hub_package = resp;
                  hub_package = self.deserialize_jptf(hub_package);
                  
                  this.compare_package(package_name, hub_package, local_package, "push", (obj) =>{
                    let fileList = obj;
                    let data = "", responsee = {};
                    if(fileList instanceof Array){
                        responsee = {"status": 200, "text": JSON.stringify({"fileList": fileList, "packageHash": hub_package.hash})};
                    } else {
                        responsee = {"status": 200, "text": JSON.stringify(fileList)}
                    }
                    return callback(null, responsee);
                  });
              } else if(response.status === 500 && resp.hasOwnProperty("message") && typeof resp.message === "string" && resp.message.startsWith("Package")){
                  this.network.pushPackage(accountSlug, slug, body, (data, response) => {
                    return callback(data, response);
                  });
              }  else {
                  return callback(data, response);
              }
            } else {
                return callback(data, response);
            }
          });
        });
      }
    }

    pullPackage (accountSlug, slug, body, callback) {
      var self          = this;
      var package_name  = accountSlug + "/" + slug;
      var network       = this.network;
      var hub_package   = {};
      var local_package = {};
      this.backend.remove_package();
      if(Object.keys(body).length > 0){
        network.pullPackage(accountSlug, slug, {"asHash": true}, (data, response) => {
          if(response){
            var resp = {};
            try{
              resp   = JSON.parse(response.text);
            }
            catch(e){
            
            }
            if(response.status === 200){
              hub_package = resp;
              hub_package = self.deserialize_jptf(hub_package);
              self.get_package(package_name, null, null, true, false, (_project) => {
                let found = false;
                for (var key in _project["content"]){
                    if( _project["content"][key]["name"] === "_package.json"){
                      found = true;
                      break;
                    }            
                }
                if(!found){
                  return callback({}, {"status": 500, "text":JSON.stringify({"message": "Invalid package. \"_package.json\" file not found.  This file must be present on root directory."})});
                }
                local_package = _project;
                self.compare_package(package_name, hub_package, local_package, "pull", (obj)=> {
                    let fileList  = obj;
                    let data  = "", 
                    responsee = {};
                    if(fileList instanceof Array){
                      responsee   = {"status": 200, "text": JSON.stringify({"fileList": fileList, "draft": []})};
                    } else {
                      responsee   = {"status": 200, "text": JSON.stringify(fileList)};
                    }
                    return callback(data, responsee);
                    });
              });
            } else {
              return callback(data, response);
            }
          } else {
            return callback(data, response);
          }
        });
      } else {
        network.pullPackage (accountSlug, slug, body, (data, response) => {
          return callback(data, response);
        })
      }
    }

    localUpdate (accountSlug, slug, body, callback) {
      var partialjptf   = [];
      var local_package = [];
      var self          = this;
      var package_name  = accountSlug + "/" + slug;
      // this.backend.remove_package();
      this.get_package(package_name, "jptf", null, true, false, (_project) => {
        local_package = _project;
        let found = false;
        for (var key in _project[0]["/"]["content"]){
            if( Object.keys(_project[0]["/"]["content"][key])[0] === "_package.json"){
              found = true;
              break;
            }            
        }
        if(!found){
          return callback({}, {"status": 500, "text":JSON.stringify({"message": "Invalid package. \"_package.json\" file not found.  This file must be present on root directory."})});
        }
        if(!(body.hasOwnProperty("replaceList") && body.hasOwnProperty("save"))){
              for (var i = 0; i< body.replaceList.length; i++){
                let jptf = self.createPartialJptf(Object.keys(body.replaceList[i])[0], local_package, body.replaceList[i][Object.keys(body.replaceList[i])[0]]);
                partialjptf.push(jptf[0]["/"]["content"][0]);
              }
              partialjptf = [{
                              "/": {
                                "hash": "",
                                "type": "directory",
                                "content": partialjptf
                              }
                            }];
              body              = {};
              body["documents"] = partialjptf;
              body["name"]      = package_name;
              body["previousPackageHash"] = local_package[0]["/"].hash;
              self.network.localUpdate(accountSlug, slug, body, (data, response) => {
                return callback(data, response);
              });
        } else {
          delete body.save;
          body["previousPackageHash"] = local_package[0]["/"].hash;
          this.network.localUpdate(accountSlug, slug, body, (data, response) => {
            return callback(data, response);
          });
        }
      });
    }

    compare_package (package_name, hub_package, local_package, action = null, callback){
      /*compare two packages*/
      var accountSlug = package_name.split('/')[0];
      var slug        = package_name.split('/')[1];
      var local_last_packageHash    = this.backend.get_hash(package_name + ".hash");
      var local_current_packageHash = local_package.hash;
      var hub_current_packageHash   = hub_package.hash;
      var self = this;

      if(action == "push"){
        if(local_current_packageHash === local_last_packageHash){
          if(hub_current_packageHash === local_last_packageHash){
            return callback([]);
          } else {
            return callback(this.differences(hub_package, local_package));
          }
        } else {
          if(hub_current_packageHash === local_last_packageHash){
            return callback({"force": true, "fileList": this.differences(hub_package, local_package), "packageHash": hub_current_packageHash});
          } else {
            if(hub_current_packageHash === local_current_packageHash){
              // save packageHash
              let partialjptf = self.as_jptf(hub_package);
              let body          = {};
              body["documents"] = partialjptf;
              body["updatePackageHash"] = this.backend.get_hash(accountSlug + "/" + slug + ".hash");
              self.network.localUpdate(accountSlug, slug, body, (data, response) => {
                return callback([]);
              });
            } else {
              return callback({"flag": true, "fileList": this.differences(hub_package, local_package), "packageHash": hub_current_packageHash});
            }
          }
        }
      } else if(action === "pull"){
        if(local_current_packageHash === local_last_packageHash){
          if(hub_current_packageHash === local_last_packageHash){
            return callback([]);
          } else {
            this.network.pullPackage(accountSlug, slug, {"force": false}, (data, response) => {
                if(response){
                  var resp = {};
                  try{
                    resp   = JSON.parse(response.text);
                  }
                  catch(e){
                  }
                  if(response.status === 200){
                    if(resp instanceof Array && resp.length > 0 && resp[0].hasOwnProperty("/")){
                      this.backend.set_hash(package_name + ".hash", resp[0]["/"]["hash"]);
                    }
                    // return {"force": true, "data": this.differences(hub_package, local_package)};
                    return callback(resp);
                  } else {
                    return callback(response.text);
                  }
              } else {
                return callback(response.text);
              }
            })
          }
        } else {
          if(hub_current_packageHash === local_last_packageHash){
            return callback(this.differences(hub_package, local_package));
          } else {
            if(hub_current_packageHash === local_current_packageHash){
              //  save package hash to host
              let partialjptf = self.as_jptf(hub_package);
              let body          = {};
              body["documents"] = partialjptf;
              body["updatePackageHash"] = this.backend.get_hash(accountSlug + "/" + slug + ".hash");
              self.network.localUpdate(accountSlug, slug, body, (data, response) => {
                return callback([]);
              });
            } else {
              return callback({"flag": true, "fileList": this.differences(hub_package, local_package)});
            }
          }
        }
      }
    }

    differences (hub_package_intermediary, local_package_intermediary){
      /* differences of two jptf objects */
      var hub_differences = this.blendedRecursiveDiff(hub_package_intermediary.content, local_package_intermediary.content);
      var local_differences = this.blendedRecursiveDiff(local_package_intermediary.content, hub_package_intermediary.content);
    
      var total_differences = hub_differences.concat(local_differences);
      total_differences =  total_differences.filter(function(item, pos) {
                              return total_differences.indexOf(item) == pos;
                          })  // unique elements of array
      return total_differences;
    }

    blendedRecursiveDiff (hub_package, local_package, track = ""){
      // => called from differences
      var list = new Array();

      for(var key in hub_package){
        var value = hub_package[key];
        if(value instanceof this.Directory){
          if(! this.findObject(local_package, hub_package[key].name, true)){
              track = track + "/" + hub_package[key].name;
              list  = this.blendedRecursiveDiff(hub_package[key]["content"], null, track).concat(list);
              track = track.split("/");
              track.pop();
              track = track.join("/");
          } else if(hub_package[key]["hash"] !== this.findObject(local_package, hub_package[key].name)["hash"]){
              track = track + "/" + hub_package[key].name;
              list  = this.blendedRecursiveDiff(hub_package[key]["content"], this.findObject(local_package, hub_package[key].name)["content"] , track).concat(list);
              track = track.split("/");
              track.pop();
              track = track.join("/");
          }
        } else if(value instanceof this.BinaryFile || value instanceof this.TextFile || value instanceof this.JSONFile){
            if(this.findObject(local_package, hub_package[key].name, true) && this.findObject(hub_package, hub_package[key].name, true)){
              if(this.findObject(hub_package, hub_package[key].name)["hash"] !== this.findObject(local_package, hub_package[key].name)["hash"]){
                let temp = track;
                track    = track + "/" + hub_package[key].name;
                list.push(track);
                track    = temp;
              }
            } else if(hub_package.hasOwnProperty(key)){
                let temp = track;
                track    = track + "/" + hub_package[key].name;
                list.push(track);
                track    = temp;
            }
        }
      }
      return list;
    }

    findObject (object, name, bool = false) {
      // finds object on basis of name and returns object (for intermediary)
      var find = false;
      for(var index in object){
        if(object[index].name === name){
          find = true;
          break;
        }
      }
      if (find){
        if(bool){
          return true
        } else {
          return object[index]
        }
      } else {
        if(bool){
          return true
        } else {
          return {}
        }
      }
    }

    getFile(accountSlug, slug, file_path, callback){

        var network              = this.network;
        var package_slug         = accountSlug + '/' + slug;
        var jptf_project         = {};
        var self = this;
        this.get_package(package_slug, "jptf", null, true, false, function(project){
              jptf_project         = project;
          let file_path_in_slash   = file_path.split("*").join("/");
          var localfileJptf        = self.createPartialJptf(file_path_in_slash, jptf_project);
          localfileJptf            = localfileJptf['0']['/']['content'];
          var localfileData        = self.getfileData(localfileJptf, file_path_in_slash);
          var hubfileJptfObject    = {};
          var content = {};
          network.getFile(accountSlug, slug, file_path, function(data, response){
              if(response){
                var resp = {}
                try{
                  resp = JSON.parse(response.text)
                } catch (e){

                }
                if(response.status == 200){
                  hubfileJptfObject = resp
                  var hubfileJptf   = hubfileJptfObject;
                  // hubfileJptf = hubfileJptf['0']['/']['content'];
                  // var hubfileData = this.getfileData(hubfileJptf, file_path);
                  var hubfileData   = hubfileJptf.remote; 
                  content = {
                  'local': localfileData,
                  'remote': hubfileData,
                  };
                  let response = {"status": 200, "text": JSON.stringify(content)} 
                  return callback(data, response); 
                } else {
                  return callback(data, response);
                }
              } else {
                return callback(data, response);
              }
          });        
        });
    }

    getfileData( jptf_project, file_path ){
        // => called from getFile

        var file_extension = file_path.split(".");
        file_extension     = file_extension[file_extension.length - 1];
        var filePath       = file_path.split('/');
        filePath.shift();
        if (Object.keys(jptf_project).length <= 0 ) {
            var content = '';
        } else {
            for(var key in filePath) {
              var value = filePath[key];
                if ((jptf_project[0] !== null) && (jptf_project[0][ value ]['content'] !== null) ) {
                    jptf_project = jptf_project[0][ value ]['content'];
                    content      = jptf_project;
                } else if (! (jptf_project[0][ value ]['href']) !== null ) {
                    content      = '';
                } else if ((jptf_project[0][ value ]['href'] !== null) ) {
                    jptf_project = jptf_project[0][ value ]['href'];
                    content      = jptf_project;
                }
            }
        }
        if(!content){
          content = '';
        }
        return content;
    }

    createPartialJptf (file_path, jptf_project, cont = null) {
      /*create partial jptf */

      var obj = this.retrieveObject(file_path, jptf_project[0]["/"]["content"]);
      var path = file_path.split(".");
      if(!obj){
            if (ALLOWED_MEDIA_TYPES.indexOf(path[path.length-1]) > -1){
                obj = {[file_path.split("/")[file_path.split("/").length-1]]: {
                        "type": "media",
                        "hash": ""
                      }}
            } else {
                obj = {[file_path.split("/")[file_path.split("/").length-1]]: {
                        "type": "file",
                        "hash": ""
                      }} 
            }
      }

      if(cont !== null && cont !== ""){
        if(obj[Object.keys(obj)[0]].type === "file"){
          obj[Object.keys(obj)[0]].content = cont;
        } else {
          obj[Object.keys(obj)[0]].href = cont;
        }
      }

      if((obj[Object.keys(obj)[0]].hasOwnProperty("href") || obj[Object.keys(obj)[0]].hasOwnProperty("content")) && cont === ""){
        obj[Object.keys(obj)[0]].hasOwnProperty("content") ? delete obj[Object.keys(obj)[0]].content : delete obj[Object.keys(obj)[0]].href;
      }

      var struct = [{
                      "/": {
                        "hash": "",
                        "type": "directory",
                        "content": []
                      }
                    }]  
      file_path = file_path.split("/");
      file_path.shift();
      var fileName  = file_path[file_path.length-1];
      this.createJptf(file_path, 1, struct[0]["/"], obj);
      return struct;

    }

    retrieveObject(path, obj){
      // => called from createPartialJptf
      /*retrieve a object in jptf with the help of path*/
        var data = JSON.parse(JSON.stringify(obj)),
            path = path.split("/"),
            i    = 0, 
            self = this,
            change  = false;
            path.shift();
        return recursion(data,i);
        function recursion(data,i){
          for(var keys in data){
              if (Object.keys(data[keys])[0] == path[i] && i == path.length-1) {
                if(!change){
                  change = true;
                  return data[keys];
                  break;
                }
              } else if (Object.keys(data[keys])[0] == path[i]) {
                return recursion(data[keys][Object.keys(data[keys])]["content"],++i);
                break;
              }  
          }
        }
    }

    createJptf(path, i, obj, object){
        //  => called from createPartialJptf
        if(path.length <= i){
          obj["content"][0] =  object
          return obj;
        } else {
           obj["content"][0] = {
            [path[i-1]]: {
                "hash": "",
                "type": "directory",
                "content": []
            }
          }
          var temp = obj["content"][0][path[i-1]];
          if(path.length > i){
           return this.createJptf(path, ++i , temp, object);
          }
        }
    }

    snapshot (package_name, callback){
      var accountSlug   = package_name.split("/")[0];
      var slug          = package_name.split("/")[1];
      var self          = this;
      var hub_package   = [];
      var local_package = [];
      this.backend.remove_package();
      this.get_package(package_name, null, null, true, false, (_project) => {
        local_package = _project;
        let found = false;
        for (var key in _project["content"]){
            if( _project["content"][key]["name"] === "_package.json"){
              found = true;
              break;
            }            
        }
        if(!found){
          return callback({}, {"status": 500, "text":JSON.stringify({"message": "Invalid package. \"_package.json\" file not found.  This file must be present on root directory."})});
        }
        this.network.pullPackage (accountSlug, slug, {"asHash": true}, (data, response) => {
            if(response){
              var resp = {};
              try{
                resp = JSON.parse(response.text);
              } catch(e){}
              if(response.status === 200){
                hub_package = resp;
                if(hub_package[0]["/"].hash === local_package.hash){
                  self.network.versionList(accountSlug, slug, (data, response) => {
                    return callback(data,response);
                  });
                } else {
                  return callback(data, {"text": JSON.stringify({"message": "out-of-sync"}), "status": 500, "statusCode": 500 });
                }

              } else {
                return callback(data, response);
              }
            } else{
              callback(data, response);
            }
        });
      });
    }

    versionCreateSnapshot (accountSlug, slug, body, callback) {
      var self          = this;
      var package_name  = accountSlug + "/" + slug;
      var local_package = [];
      this.backend.remove_package();
      this.get_package(package_name, null, null, true, false, (_project) => {
        local_package = _project;
        body["hash_as_token"] = local_package.hash;
        this.network.versionCreateSnapshot (accountSlug, slug, body, (data, response) => {
          if(response){
            var resp = {};
            try{
              resp   = JSON.parse(response.text);
            } catch(e){}
            if(response.status === 200){
              this.network.versionList(accountSlug, slug, (data, response) => {
                return callback(data, response);
              })
            } else {
              return callback(data, response)
            }
          } else{
            return callback(data, response);
          }
        });
      });
    }

    updateFromLocal (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
      var package_name  = accountSlug1 + "/" + slug1;
      var local_package = [];

      this.get_package(package_name, "jptf", null, true, false, (_project) => {
        local_package = _project;
        body["previousPackageHash"] = local_package[0]["/"].hash;
        this.network.updateFromLocal(accountSlug1, slug1, accountSlug2, slug2, body, opts, (data, response) => {
          return callback(data, response);
        });
      });
    }

    updateFromVersion (accountSlug1, slug1, accountSlug2, slug2, label, body, opts, callback) {
      var package_name  = accountSlug1 + "/" + slug1;
      var local_package = [];

      this.get_package(package_name, "jptf", null, true, false, (_project) => {
        local_package = _project;
        body["previousPackageHash"] = local_package[0]["/"].hash;
        this.network.updateFromVersion (accountSlug1, slug1, accountSlug2, slug2, label, body, opts, (data, response) => {
          return callback(data, response);
        });
      });
    }

}

module.exports = {Controller: Controller};



/** WEBPACK FOOTER **
 ** ./~/blended-hostlib-js/Controller/index.js
 **/